// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"236":"f026a9ab","482":"de5ea9a8","527":"0782f9ab","787":"512e832b","815":"5a2d9bbb","829":"0420fb75","944":"1f8b6329"}[chunkId] + ".chunk.js";
};